export default "__VITE_ASSET__hzuID4z4__"